import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Image } from "antd";
import YoutubeIcon from '../../../../assets/YoutubeIcon';

export const getProgressNextAction = (progress, userDetails) => {
    const kycDone = progress?.kyc ?? !!userDetails?.kycStatus;
    const depositDone = !!progress?.deposit;
    const liveAccountDone = !!progress?.isLiveAccount;

    if (!kycDone) {
        return {
            label: 'Complete KYC',
            path: '/kyc',
            state: { title: 'Complete KYC' },
            message: "To get started, please complete your KYC process",
        };
    }
    if (!depositDone) {
        return {
            label: 'Deposit',
            path: '/deposit',
            state: { title: 'Deposit' },
            message: "To get started, please make your first deposit",
        };
    }
    return {
        label: 'Open Live Account',
        path: '/account?type=live',
        state: { title: 'Open Live Account' },
        message: "To get started, you'll need to create an account",
    };
};

const CreateLiveAccount = ({ progress }) => {
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.user);
    const [isOpenModal, setIsOpenModal] = useState(false);

    const nextAction = getProgressNextAction(progress, userDetails);

    return (
        <div className='flex justify-center items-center flex-col h-[calc(100vh-150px)]'>
            <img src="/assets/images/welcome.svg" alt="" style={{ height: 350, width: '100%' }} />
            <div>
            </div>
            <div className=''>
                <p className="font-bold text-[#2F2B3D] sm:text-4xl text-xl text-center">👋 Welcome <span className=' primary font-semibold capitalize'>
                    {userDetails?.firstName} {userDetails?.lastName}</span></p>
            </div>
            <p className="mt-4 text-center">Your trading dashboard is ready. Manage risks wisely, and let opportunities come to you</p>
            <p className="mt-4 text-center">
                {nextAction.message}
            </p>

            <div className='w-full sm:w-auto px-4 sm:px-0 mt-5'>
                <button
                    className='bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover duration-500 w-full sm:w-auto'
                    onClick={() => navigate(nextAction.path, { state: nextAction.state })}
                >
                    {nextAction.label}
                </button>
            </div>

            <div className='w-full sm:w-auto px-4 sm:px-0 mt-7'>
                <button className='bg-[var(--theme2)] text-white font-semibold px-9 py-2 rounded-lg flex justify-center items-center gap-2 w-full sm:w-auto' onClick={() => setIsOpenModal(true)} >
                    <span><YoutubeIcon /></span> <span>View Tutorial For Getting Started</span>
                </button>
            </div>

            {isOpenModal && (
                <Image
                    style={{ display: "none" }}
                    preview={{
                        visible: isOpenModal,
                        onVisibleChange: (value) => setIsOpenModal(value),
                        destroyOnHidden: true,
                        maskClassName: "!bg-black !bg-opacity-90",
                        imageRender: () => (
                            <div className="fixed inset-0  bg-opacity-60 flex items-center justify-center p-4">
                                <div className="w-full h-full max-w-6xl flex items-center justify-center">
                                    <div className='relative w-full h-full'>
                                        <iframe
                                            src="https://www.youtube.com/embed/videoseries?list=PLQf-ZwtTMD1UMJVceEsEUIv7MrvH6qNCC&autoplay=1"
                                            title="Process Video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ),
                        toolbarRender: () => null,
                    }}
                />
            )}


        </div>
    )
}

export default CreateLiveAccount
